import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const LayoutWrapper = styled.div`
  background-color: #ffffff;
  min-height: 100vh;
  max-width: 1440px;
  margin: 0 auto;
  color: ${props => props.theme.carvana.white.primary};
  box-shadow: rgb(0 0 0 / 5%) 0px 0px 35px;
`;
